/* eslint-disable no-lonely-if */
/* eslint-disable no-nested-ternary */
import React, { ReactElement, useMemo } from 'react';

import { Col, Divider, Layout, Row, TypographyText } from '@components/atoms';
import { noYnSurveys, requiredYnSurveys } from '@constants/enum';
import { MAIN_CATEGORY_GUIDE, MAIN_CATEGORY_TITLE, NO_ANSWER } from '@constants/text';
import { useReduxForm } from '@hooks/useReduxForm';
import { getSurveyObj } from '@utils/surveyUtils';
import _ from 'lodash';

function MainCategory(): ReactElement {
  /**
   * 어떤 설문들을 진행할 지 결정하는 화면
   * surveyList: string[] - 선택된 설문 코드를 저장하는 배열
   * */
  const { formData, setFormData } = useReduxForm('survey');
  const { mainSurveyList, selectedMainSurveyCode } = formData;

  const category = useMemo(
    () => [
      ..._.map(mainSurveyList, (k: string, index: number) => ({
        index,
        label: getSurveyObj(k).label,
        value: k,
      })),
      {
        label: NO_ANSWER,
        value: 0,
      },
    ],
    [],
  );

  return (
    <Layout yzTypeLayout="SURVEY">
      <Row>
        <Col yzTypeCol="center">
          <TypographyText yzTypeTypographyText="title">{MAIN_CATEGORY_TITLE}</TypographyText>
        </Col>
      </Row>
      <Divider margin={6} yzTypeDivider="TRANSPARENT_LITTLE_SPACE" />
      <Row>
        <Col yzTypeCol="center">
          <TypographyText yzTypeTypographyText="basic">{MAIN_CATEGORY_GUIDE}</TypographyText>
        </Col>
      </Row>
      <Divider margin={8} yzTypeDivider="TRANSPARENT_LITTLE_SPACE" />
      <Row gutter={[0, 5]} style={{ rowGap: '6px', paddingInline: '5px' }}>
        {
          // eslint-disable-next-line react/no-unused-prop-types
          category.map(({ value, label }) => {
            const checked = selectedMainSurveyCode === value;
            return (
              <Col
                onClick={() => {
                  if (checked) {
                    const body = {
                      [value]: 0,
                      [`${value}Next`]: undefined,
                      selectedMainSurveyCode: undefined,
                      surveyList: [],
                    };
                    setFormData(body);
                    // console.log(body);
                  } else {
                    if (value === 0) {
                      const body: any = {
                        [selectedMainSurveyCode]: 0,
                        [`${selectedMainSurveyCode}Next`]: undefined,
                        selectedMainSurveyCode: 0,
                        surveyList: [],
                      };
                      setFormData(body);
                    } else {
                      const body: any = {
                        selectedMainSurveyCode: value,
                        surveyList: [value],
                      };
                      if (selectedMainSurveyCode !== 0) {
                        body[selectedMainSurveyCode] = 0;
                        body[`${selectedMainSurveyCode}Next`] = undefined;
                      }
                      if (![...requiredYnSurveys, ...noYnSurveys].includes(value)) {
                        body[value] = 1;
                        body[`${value}Next`] = getSurveyObj(value)?.answers?.find((e) => e?.value)?.next;
                      }
                      setFormData(body);
                    }
                    // console.log(body);
                  }
                }}
                span={12}
                style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                twoColumnsInRowFlag
                yzTypeCol={checked ? 'selected-onset-button' : 'onset-button'}
              >
                <TypographyText yzTypeTypographyText="basic">{label}</TypographyText>
              </Col>
            );
          })
        }
      </Row>
      <Divider margin={42} yzTypeDivider="TRANSPARENT_LITTLE_SPACE" />
    </Layout>
  );
}

export default MainCategory;
